import { useRef } from "react";
import { useTranslation } from "react-i18next";

const fileSizeToWord = (size) => {
  const sizeInKB = size / 1024;
  const sizeInMB = sizeInKB / 1024;
  if (sizeInKB < 1) {
    return `${size} bytes`;
  } else if (sizeInMB < 1) {
    return `${Math.round(sizeInKB)} KB`;
  } else if (sizeInMB < 1024) {
    return `${Math.round(sizeInMB)} MB`;
  } else {
    return `${Math.round(sizeInMB / 1024)} GB`;
  }
};

const UploadWrapper = ({ children, maxSizeInMegaBytes = 5, onFileChange }) => {
  const { t } = useTranslation();

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.size > maxSizeInMegaBytes * 1024 * 1024) {
        alert(
          t("UploadWrapper.MaxSizeAlert", {
            size: fileSizeToWord(maxSizeInMegaBytes * 1024 * 1024),
          })
        );
        return;
      }

      onFileChange(file);
    }
  };

  return (
    <>
      {children(handleClick)}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default UploadWrapper;
